import bodymovin from 'lottie-web';
import { isFunction } from '../functions';

export default class BodyMovin {
  constructor($element) {
    this.$element = $element;
    this.src = $element.dataset.src;

    let loop = undefined;
    try {
      loop = JSON.parse(this.$element.dataset.loop);
    } catch (e) {
      loop = true;
    }

    this.animation = bodymovin.loadAnimation({
      container: this.$element,
      renderer: 'svg',
      loop: loop,
      autoplay: false,
      path: this.src,
    })

    if(isFunction(IntersectionObserver)) {
      let observer = new IntersectionObserver(this.onObservation.bind(this));
      observer.observe(this.$element);
    } else {
      this.animation.play();
    }
  }

  onObservation(intersections) {
    const inters = intersections[0];
    if (this.animation.isPaused && inters.isIntersecting) {
      this.animation.play();
    } else if (!inters.isIntersecting) {
      this.animation.stop();
    }
  }

  play() {
    if ( this.animation.isPaused ) this.animation.play();
  }

  pause() {
    this.animation.pause();
  }

  stop() {
    this.animation.stop();
  }
}



// WEBPACK FOOTER //
// ./scripts/dom/BodyMovin.js